(function () {
'use strict';

const whySelector = "[id$='__carousel_ztY6t8']";
const productsSelector = "[id$='__product_list_fa6P9H']";
const collectionsSelector = "[id$='__collection_list_QxtUhL']";
const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function initCanonicalStorefrontLinks(scope = document) {
  const adminOrigin = 'https://r7509v-ga.myshopify.com';
  if (window.location.origin === adminOrigin) return;

  scope.querySelectorAll?.(`a[href^="${adminOrigin}/"]`).forEach((link) => {
    const target = new URL(link.href);
    link.href = `${window.location.origin}${target.pathname}${target.search}${target.hash}`;
  });
}

function initAccessibleLabels(scope = document) {
  const hero = scope.querySelector?.("[id$='__hero_jVaWmY'] img.hero__media");
  if (hero && !hero.hasAttribute('alt')) {
    hero.alt = 'Campanha ROSERA — Vintage Minimal Wear';
  }

  scope.querySelectorAll?.('product-card').forEach((card) => {
    const title = card.querySelector('h3')?.textContent.trim();
    const quickAdd = card.querySelector('button.quick-add__button');
    if (title && quickAdd && !quickAdd.getAttribute('aria-label')) {
      quickAdd.setAttribute('aria-label', `Escolher opções de ${title}`);
    }
  });
}

function initWhyRosera(scope = document) {
  const section = scope.matches?.(whySelector) ? scope : scope.querySelector?.(whySelector);
  if (!section) return;

  section.querySelectorAll('.carousel-content [data-carousel-card]').forEach((card) => {
    if (card.dataset.rsWhyReady === 'true') return;
    const title = card.querySelector(
      '.text-block--text_a3pcmh, .text-block--text_NdhRDc, .text-block--text_Xhn6Dp'
    );
    card.tabIndex = 0;
    card.setAttribute('role', 'group');
    if (title?.textContent.trim()) card.setAttribute('aria-label', title.textContent.trim());
    card.dataset.rsWhyReady = 'true';
  });
}

function cloneGalleryImage(image, className) {
  const clone = image.cloneNode(true);
  clone.className = className;
  clone.alt = '';
  clone.setAttribute('aria-hidden', 'true');
  clone.draggable = false;
  clone.removeAttribute('id');
  return clone;
}

function initProductHover(scope = document) {
  if (!finePointer.matches) return;

  const section = scope.matches?.(productsSelector) ? scope : scope.querySelector?.(productsSelector);
  if (!section) return;

  section.querySelectorAll('product-card:not([data-rs-hover-ready])').forEach((card) => {
    const gallery = card.querySelector('.card-gallery');
    const slides = gallery?.querySelectorAll('slideshow-slide:not([hidden])');
    if (!gallery || !slides || slides.length < 2) return;

    const firstImage = slides[0].querySelector('img');
    const secondImage = slides[1].querySelector('img');
    if (!firstImage || !secondImage) return;

    const firstSource = firstImage.currentSrc || firstImage.src;
    const secondSource = secondImage.currentSrc || secondImage.src;
    if (!firstSource || !secondSource || firstSource === secondSource) return;

    const layer = document.createElement('div');
    layer.className = 'rs-product-hover-layer';
    layer.setAttribute('aria-hidden', 'true');
    layer.append(
      cloneGalleryImage(firstImage, 'rs-product-hover-layer__first'),
      cloneGalleryImage(secondImage, 'rs-product-hover-layer__second')
    );

    const slideshow = gallery.querySelector('slideshow-component');
    if (slideshow) slideshow.after(layer);
    else gallery.prepend(layer);
    card.dataset.rsHoverReady = 'true';
  });
}

function initCollectionCards(scope = document) {
  const section = scope.matches?.(collectionsSelector) ? scope : scope.querySelector?.(collectionsSelector);
  if (!section) return;

  section.querySelectorAll('.collection-card:not([data-rs-collection-ready])').forEach((card) => {
    const link = card.querySelector('.collection-card__link');
    const content = card.querySelector('.collection-card__content');
    const title = content?.querySelector('.text-block')?.textContent.trim();
    if (!link || !content) return;

    if (title) link.setAttribute('aria-label', `Ver coleção: ${title}`);
    card.dataset.rsCollectionReady = 'true';
  });
}

function initProofReal(scope = document) {
  const roots = scope.matches?.('.rs-proof') ? [scope] : scope.querySelectorAll?.('.rs-proof') || [];

  roots.forEach((root) => {
    const introduction = root.querySelector('.rs-proof__head > p');
    if (introduction) {
      introduction.textContent = 'Conversas, marcações e avaliações compartilhadas pela comunidade ROSERA.';
    }

    const viewport = root.querySelector('[data-proof-viewport]');
    if (viewport) viewport.setAttribute('aria-label', 'Avaliações e marcações da comunidade ROSERA');

    const originalCards = root.querySelectorAll('[data-proof-group] .rs-proof__card');
    originalCards.forEach((card, index) => {
      card.setAttribute('aria-label', `Avaliação da comunidade ${index + 1} de ${originalCards.length}`);
      card.querySelector('.rs-proof__body')?.remove();
    });

    root.querySelectorAll('[data-proof-group] .rs-proof__card').forEach((card) => {
      card.tabIndex = 0;
    });

    const toggle = root.querySelector('[data-proof-toggle]');
    const syncMotionControl = () => {
      if (!toggle) return;
      toggle.hidden = reducedMotion.matches;
      toggle.disabled = reducedMotion.matches;
      root.classList.toggle('rs-proof--reduced', reducedMotion.matches);
    };
    syncMotionControl();

    if (root.dataset.rsProofEnhanced !== 'true') {
      reducedMotion.addEventListener?.('change', syncMotionControl);
      root.dataset.rsProofEnhanced = 'true';
    }

    if ('IntersectionObserver' in window && !root.dataset.rsProofObserved) {
      const observer = new IntersectionObserver(
        ([entry]) => root.classList.toggle('rs-proof--offscreen', !entry.isIntersecting),
        { rootMargin: '120px 0px' }
      );
      observer.observe(root);
      root.dataset.rsProofObserved = 'true';
    }
  });
}

function initSupportPaths(scope = document) {
  const roots = scope.matches?.('.rs-support') ? [scope] : scope.querySelectorAll?.('.rs-support') || [];
  const labels = [
    ['DÚVIDAS SOBRE TAMANHO', 'Fale com a ROSERA antes de escolher.'],
    ['ENVIO E ENTREGA', 'Consulte as condições registradas pela loja.'],
    ['TROCAS E CONTATO', 'Veja a política e os canais de atendimento.'],
  ];

  roots.forEach((root) => {
    root.querySelectorAll('.rs-support__links > a').forEach((link, index) => {
      const label = labels[index];
      if (!label) return;
      const strong = link.querySelector('strong');
      const small = link.querySelector('small');
      if (strong) strong.textContent = label[0];
      if (small) small.textContent = label[1];
      link.setAttribute('aria-label', label[0]);
    });
  });
}

function initRoseraInteractions(scope = document) {
  [
    initCanonicalStorefrontLinks,
    initAccessibleLabels,
    initWhyRosera,
    initProductHover,
    initCollectionCards,
    initProofReal,
    initSupportPaths,
  ].forEach((initializer) => {
    try {
      initializer(scope);
    } catch (error) {
      console.error(`[ROSERA] ${initializer.name} falhou`, error);
    }
  });
  document.documentElement.dataset.rsInteractions = 'ready';
}

initRoseraInteractions(document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initRoseraInteractions(document), { once: true });
} else {
  initRoseraInteractions(document);
}

window.addEventListener('load', () => initRoseraInteractions(document), { once: true });

// O menu do Horizon pode ser renderizado depois do script principal. Duas
// tentativas curtas garantem que links internos nunca saiam do domínio público.
window.setTimeout(() => initCanonicalStorefrontLinks(document), 350);
window.setTimeout(() => initCanonicalStorefrontLinks(document), 1200);

document.addEventListener('shopify:section:load', (event) => {
  initRoseraInteractions(event.target);
});

finePointer.addEventListener?.('change', () => initProductHover(document));

})();
